import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 格式化本地时间
 * @param {*} time
 */
export const formatLocalTime = (format, time = null) => {
  return (time ? dayjs(time) : dayjs()).format(format);
};

/**
 * 格式化 uct 时间
 */
export const formatUTCTime = (format, time = null) => {
  return (time ? dayjs(time) : dayjs()).utc(!!time).format(format);
};

/**
 * 获取 dayjs 对象
 */
export const convertUTCTimeToLocal = (time) => {
  return dayjs(time).utc(true).local();
};
